import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ClientAccountCompany } from "../../Types/HeyTraderTypes/ClientAccountTypes/ClientAccountType";
import { getAllCompanyList } from "../../Thunks/HeyTraderThunks";

interface ClientAccountCompanySliceState {
  loader: boolean; // for refres pages and inital loadings
  companyList: ClientAccountCompany[];
  errorDisplay: string | null;
}

// set inital valus
const initialState: ClientAccountCompanySliceState = {
  loader: false,
  companyList: [],
  errorDisplay: "",
};

// set state valu for api response
const clientAccountCompanySlice = createSlice({
  name: "clientAccountCompany",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getAllCompanyList.rejected, (state, action) => {
        state.loader = false;
        state.errorDisplay = action.error.message!;
      })
      .addCase(getAllCompanyList.pending, (state) => {
        state.loader = true;
        state.errorDisplay = null;
      })
      .addCase(
        getAllCompanyList.fulfilled,
        (state, action: PayloadAction<ClientAccountCompany[]>) => {
          state.loader = false;
          state.companyList = action.payload;
        }
      );
  },
});

export const {} = clientAccountCompanySlice.actions;
export default clientAccountCompanySlice.reducer;
